import React from "react";
import "./NotFound.css";
import Footer from "../Footer/Footer";

const NotFound = () => (
  <>
    <main className="notfound-container">
      <section className="notfound scroll-panel">
        <div className="notfound-content">
          <h1 className="notfound-title">🧭 404 — Lost in Backendia</h1>
          <p className="notfound-message">
            The scroll you seek cannot be found.
            <br />
            Perhaps it was devoured by a bug, or never existed at all...
          </p>
        </div>
        <div className="notfound-image-placeholder">
          <img
            src={process.env.PUBLIC_URL + "/404duck.png"}
            alt="Lost in Backendia"
            className="notfound-image"
          />
          <a href="/" className="notfound-home-link">
            Return to the Realm
          </a>
        </div>
      </section>
    </main>
    <Footer />
  </>
);

export default NotFound;
